import { faCircleXmark, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Popper, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  CircleXIcon,
  CustomAutocomplete,
  CustomPaperStyled,
  CustomTextField,
  NoText,
  SearchIcon,
  SearchIconContainer,
} from './TrlSearch.styles';
import { TrlSearchItems } from './TrlSearchItems';

const CustomPopper = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return <Popper {...props} placement={isMobile ? 'top' : 'bottom'} />;
};

export const TrlSearch = ({
  id,
  options,
  placeholder,
  getOptionLabel,
  isOptionEqualToValue,
  onChange,
  hasCustomPopper,
  renderLeftSlot,
  renderRightSlot,
  paperId,
  fullWidth,
  uppercaseLetters,
  hasLeftStraip,
  ...rest
}) => {
  const CustomPaper = (props) => (
    <CustomPaperStyled id={paperId} fullWidth={fullWidth} {...props} />
  );

  return (
    <CustomAutocomplete
      options={options}
      noOptionsText={
        <NoText>
          <CircleXIcon icon={faCircleXmark} />
          <FormattedMessage id="TRLT_UI-NO_RESULTS" />
        </NoText>
      }
      fullWidth={fullWidth}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      isSearchBar={id === 'txbSearch'}
      onChange={onChange}
      slots={{
        paper: CustomPaper,
        ...(hasCustomPopper ? { popper: CustomPopper } : {}),
      }}
      renderOption={(props, option) => (
        <TrlSearchItems
          option={option}
          leftSlot={renderLeftSlot?.(option)}
          rightSlot={renderRightSlot?.(option)}
          uppercaseLetters={uppercaseLetters}
          hasLeftStraip={hasLeftStraip}
          {...props}
        />
      )}
      renderInput={(params) => (
        <CustomTextField
          autoFocus={false}
          {...params}
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: (
                <SearchIconContainer position="start">
                  <SearchIcon icon={faSearch} />
                </SearchIconContainer>
              ),
            },
          }}
          placeholder={placeholder}
          fullWidth={fullWidth}
          uppercaseLetters={uppercaseLetters}
        />
      )}
      {...rest}
    />
  );
};

TrlSearch.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  getOptionLabel: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
  onChange: PropTypes.func,
  hasCustomPopper: PropTypes.bool,
  renderLeftSlot: PropTypes.func,
  renderRightSlot: PropTypes.func,
  paperId: PropTypes.string,
  fullWidth: PropTypes.bool,
  uppercaseLetters: PropTypes.bool,
  hasLeftStraip: PropTypes.bool,
};
